import React, { FC } from 'react'
import css from './Video.module.scss'
import Player from '../../../common/Player/Player'
import { IPlayer } from '../../../types'

const Video: FC<{ video: IPlayer }> = ({ video }) => {
  if (!video) {
    return null
  }
  return (
    <div className={css.video}>
      <Player {...video} />
    </div>
  )
}

export default Video
